// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════════
   Account & Subscription screen
   ════════════════════════════════════════════════════════ */

/* ── RBAC access-denied state ────────────────────────── */
.as-access-denied {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 300px;
  padding: 40px 24px;
  text-align: center;
  background: #f8fafc;
}
.as-access-denied-icon {
  font-size: 48px;
  margin-bottom: 16px;
}
.as-access-denied-title {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px;
}
.as-access-denied-body {
  font-size: 14px;
  color: #64748b;
  max-width: 380px;
  line-height: 1.6;
  margin: 0 0 24px;
}
.as-access-denied-btn {
  padding: 10px 24px;
  background: #3b82f6;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
.as-access-denied-btn:hover {
  background: #2563eb;
}

.as-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f8fafc;
  font-family: inherit;
}

/* ── Header ─────────────────────────────────────────────── */
.as-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: #fff;
  border-bottom: 1.5px solid #e2e8f0;
  flex-shrink: 0;
}
.as-back {
  width: 32px;
  height: 32px;
  border: 1.5px solid #e2e8f0;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #475569;
  flex-shrink: 0;
  transition: border-color 0.15s, background 0.15s;
}
.as-back:hover { background: #f1f5f9; border-color: #cbd5e1; }
.as-header-title { font-size: 15px; font-weight: 700; color: #0f172a; margin: 0; }
.as-header-sub   { font-size: 11.5px; color: #64748b; margin: 1px 0 0; }

/* ── Scroll body ─────────────────────────────────────────── */
.as-body {
  flex: 1;
  overflow-y: auto;
  padding: 18px 20px 32px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ── Meta chips row ──────────────────────────────────────── */
.as-chips-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.as-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px 5px 9px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: 600;
  border: 1px solid;
}
.as-chip-blue {
  background: #2563eb1a;
  border-color: #2563eb33;
  color: #1d4ed8;
}
.as-chip-navy {
  background: #1e3a5f1a;
  border-color: #1e3a5f33;
  color: #1e3a5f;
}
.as-chip svg { flex-shrink: 0; }

/* ── Timestamp + refresh row ─────────────────────────────── */
.as-meta-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}
.as-updated {
  font-size: 11px;
  color: #94a3b8;
}
.as-refresh-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 16px;
  border-radius: 12px;
  border: 1.5px solid #2563eb33;
  background: #eef3ff;
  color: #2563eb;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
  white-space: nowrap;
}
.as-refresh-btn:hover { background: #dbeafe; }
.as-refresh-btn:disabled { opacity: 0.55; cursor: not-allowed; }
.as-refresh-spinner {
  width: 13px;
  height: 13px;
  border: 2px solid #2563eb44;
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: as-spin 0.7s linear infinite;
}
@keyframes as-spin { to { transform: rotate(360deg); } }

/* ── Empty state ─────────────────────────────────────────── */
.as-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  gap: 12px;
  text-align: center;
}
.as-empty-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #2563eb14;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2563eb;
}
.as-empty-title { font-size: 15px; font-weight: 700; color: #0f172a; margin: 0; }
.as-empty-msg   { font-size: 13px; color: #64748b; margin: 0; max-width: 300px; }

/* ── Generic card ────────────────────────────────────────── */
.as-card {
  background: #fff;
  border-radius: 18px;
  border: 1.5px solid #e2e8f0;
  overflow: hidden;
  box-shadow: 0 2px 8px 0 #0000000a;
}

/* ── Card accent header ──────────────────────────────────── */
.as-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 13px 16px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.as-card-header-blue   { background: #2563eb12; color: #1d4ed8; }
.as-card-header-purple { background: #7c3aed12; color: #6d28d9; }
.as-card-header-amber  { background: #d9770614; color: #b45309; }
.as-card-header-red    { background: #dc262614; color: #b91c1c; }

/* ── Plan / billing banner ───────────────────────────────── */
.as-plan-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
}
.as-plan-name { font-size: 20px; font-weight: 700; color: #0f172a; }

.as-billing-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 13px 16px;
  background: #7c3aed07;
  border-bottom: 1px solid #f1f5f9;
}
.as-billing-banner-left  { display: flex; flex-direction: column; gap: 2px; }
.as-billing-banner-right { display: flex; flex-direction: column; align-items: flex-end; gap: 2px; }
.as-billing-label { font-size: 11px; color: #64748b; font-weight: 500; }
.as-billing-amount { font-size: 19px; font-weight: 700; color: #0f172a; }
.as-billing-due-days { font-size: 14px; font-weight: 700; color: #7c3aed; }

/* ── Status badge ────────────────────────────────────────── */
.as-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}
.as-status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}
.as-status-active   { background: #05966914; color: #059669; }
.as-status-active   .as-status-dot { background: #059669; }
.as-status-inactive { background: #dc262614; color: #dc2626; }
.as-status-inactive .as-status-dot { background: #dc2626; }
.as-status-other    { background: #d9770614; color: #d97706; }
.as-status-other    .as-status-dot { background: #d97706; }

/* ── Data rows (label + value) ───────────────────────────── */
.as-rows { padding: 6px 0 8px; }
.as-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: 9px 16px;
  border-bottom: 1px solid #f8fafc;
  gap: 12px;
}
.as-row:last-child { border-bottom: none; }
.as-row-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
  flex-shrink: 0;
}
.as-row-value {
  font-size: 12.5px;
  color: #0f172a;
  font-weight: 600;
  text-align: right;
  word-break: break-all;
}
.as-row-value-purple { color: #7c3aed; }

/* ── Features collapsible ────────────────────────────────── */
.as-features-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-top: 1px solid #f1f5f9;
  cursor: pointer;
  background: none;
  border-bottom: none;
  border-left: none;
  border-right: none;
  width: 100%;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  transition: background 0.12s;
}
.as-features-toggle:hover { background: #f8fafc; }
.as-features-chevron { transition: transform 0.2s; }
.as-features-chevron.open { transform: rotate(180deg); }

.as-features-body { padding: 4px 16px 12px; }
.as-feat-group-label {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
  padding: 8px 0 4px;
}
.as-feat-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 0;
  font-size: 12px;
  color: #334155;
}
.as-feat-icon-ok  { color: #059669; flex-shrink: 0; }
.as-feat-icon-no  { color: #dc2626; flex-shrink: 0; }


/* ── Addon rows ──────────────────────────────────────────── */
.as-addon-list { display: flex; flex-direction: column; }
.as-addon-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid #f8fafc;
}
.as-addon-row:last-child { border-bottom: none; }
.as-addon-left  { display: flex; flex-direction: column; gap: 3px; flex: 1; min-width: 0; }
.as-addon-right { display: flex; flex-direction: column; align-items: flex-end; gap: 4px; flex-shrink: 0; }
.as-addon-name  { font-size: 13px; font-weight: 700; color: #0f172a; }
.as-addon-desc  { font-size: 11.5px; color: #64748b; line-height: 1.4; }
.as-addon-id    { font-size: 10.5px; color: #94a3b8; }
.as-addon-badges { display: flex; flex-wrap: wrap; gap: 5px; margin-top: 2px; }
.as-category-pill {
  display: inline-flex;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  background: #d9770614;
  color: #b45309;
}
.as-addon-cycle { font-size: 11px; color: #94a3b8; margin-top: 1px; }
.as-addon-price-free  { font-size: 14px; font-weight: 700; color: #059669; }
.as-addon-price       { font-size: 14px; font-weight: 700; color: #b45309; }
.as-addon-dates       { font-size: 10.5px; color: #94a3b8; text-align: right; }
.as-addon-empty       { padding: 14px 16px; font-size: 12px; color: #94a3b8; }

/* ── Dark mode ───────────────────────────────────────────── */
body.dark .as-container { background: #0f172a; }
body.dark .as-header    { background: #1e293b; border-color: #334155; }
body.dark .as-header-title { color: #f1f5f9; }
body.dark .as-header-sub   { color: #94a3b8; }
body.dark .as-back      { background: #1e293b; border-color: #334155; color: #94a3b8; }
body.dark .as-card      { background: #1e293b; border-color: #334155; box-shadow: none; }
body.dark .as-row       { border-color: #1e293b; }
body.dark .as-row-label { color: #94a3b8; }
body.dark .as-row-value { color: #e2e8f0; }
body.dark .as-plan-banner { border-color: #334155; }
body.dark .as-plan-name   { color: #f1f5f9; }
body.dark .as-addon-name  { color: #f1f5f9; }
body.dark .as-features-toggle { color: #94a3b8; }
body.dark .as-features-toggle:hover { background: #0f172a; }
body.dark .as-feat-group-label { color: #64748b; }
body.dark .as-feat-row  { color: #cbd5e1; }
body.dark .as-addon-row { border-color: #1e293b; }
body.dark .as-addon-desc { color: #94a3b8; }
body.dark .as-empty-title { color: #f1f5f9; }
body.dark .as-billing-amount { color: #f1f5f9; }
body.dark .as-updated { color: #475569; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/AccountSubscription/index.css"],"names":[],"mappings":"AAAA;;6DAE6D;;AAE7D,2DAA2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,gDAAgD;AAClD;AACA,iBAAiB,mBAAmB,EAAE,qBAAqB,EAAE;AAC7D,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE;AACjF,mBAAmB,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE;;AAEvE,+DAA+D;AAC/D;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;AAChB;AACA,eAAe,cAAc,EAAE;;AAE/B,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;AACA,wBAAwB,mBAAmB,EAAE;AAC7C,2BAA2B,aAAa,EAAE,mBAAmB,EAAE;AAC/D;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;AACzC;AACA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD,+DAA+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE;AAChF,kBAAkB,eAAe,EAAE,cAAc,EAAE,SAAS,EAAE,gBAAgB,EAAE;;AAEhF,+DAA+D;AAC/D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA,yBAAyB,qBAAqB,EAAE,cAAc,EAAE;AAChE,yBAAyB,qBAAqB,EAAE,cAAc,EAAE;AAChE,yBAAyB,qBAAqB,EAAE,cAAc,EAAE;AAChE,yBAAyB,qBAAqB,EAAE,cAAc,EAAE;;AAEhE,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;AAClC;AACA,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAEnE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;AAClC;AACA,2BAA2B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC5E,2BAA2B,aAAa,EAAE,sBAAsB,EAAE,qBAAqB,EAAE,QAAQ,EAAE;AACnG,oBAAoB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACvE,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACxE,uBAAuB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAE1E,+DAA+D;AAC/D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA,sBAAsB,qBAAqB,EAAE,cAAc,EAAE;AAC7D,qCAAqC,mBAAmB,EAAE;AAC1D,sBAAsB,qBAAqB,EAAE,cAAc,EAAE;AAC7D,qCAAqC,mBAAmB,EAAE;AAC1D,sBAAsB,qBAAqB,EAAE,cAAc,EAAE;AAC7D,qCAAqC,mBAAmB,EAAE;;AAE1D,+DAA+D;AAC/D,WAAW,kBAAkB,EAAE;AAC/B;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;EACjB,gCAAgC;EAChC,SAAS;AACX;AACA,qBAAqB,mBAAmB,EAAE;AAC1C;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;AACA,uBAAuB,cAAc,EAAE;;AAEvC,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;AACA,4BAA4B,mBAAmB,EAAE;AACjD,uBAAuB,0BAA0B,EAAE;AACnD,4BAA4B,yBAAyB,EAAE;;AAEvD,oBAAoB,sBAAsB,EAAE;AAC5C;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA,oBAAoB,cAAc,EAAE,cAAc,EAAE;AACpD,oBAAoB,cAAc,EAAE,cAAc,EAAE;;;AAGpD,+DAA+D;AAC/D,iBAAiB,aAAa,EAAE,sBAAsB,EAAE;AACxD;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;AACA,2BAA2B,mBAAmB,EAAE;AAChD,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,OAAO,EAAE,YAAY,EAAE;AAC1F,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,qBAAqB,EAAE,QAAQ,EAAE,cAAc,EAAE;AAC1G,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACrE,kBAAkB,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACvE,kBAAkB,iBAAiB,EAAE,cAAc,EAAE;AACrD,mBAAmB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC9E;EACE,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;AACA,kBAAkB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACpE,wBAAwB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC3E,wBAAwB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC3E,wBAAwB,iBAAiB,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAC9E,wBAAwB,kBAAkB,EAAE,eAAe,EAAE,cAAc,EAAE;;AAE7E,+DAA+D;AAC/D,0BAA0B,mBAAmB,EAAE;AAC/C,0BAA0B,mBAAmB,EAAE,qBAAqB,EAAE;AACtE,6BAA6B,cAAc,EAAE;AAC7C,6BAA6B,cAAc,EAAE;AAC7C,0BAA0B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACtF,0BAA0B,mBAAmB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE;AACxF,0BAA0B,qBAAqB,EAAE;AACjD,0BAA0B,cAAc,EAAE;AAC1C,0BAA0B,cAAc,EAAE;AAC1C,4BAA4B,qBAAqB,EAAE;AACnD,4BAA4B,cAAc,EAAE;AAC5C,4BAA4B,cAAc,EAAE;AAC5C,gCAAgC,cAAc,EAAE;AAChD,sCAAsC,mBAAmB,EAAE;AAC3D,iCAAiC,cAAc,EAAE;AACjD,0BAA0B,cAAc,EAAE;AAC1C,0BAA0B,qBAAqB,EAAE;AACjD,2BAA2B,cAAc,EAAE;AAC3C,4BAA4B,cAAc,EAAE;AAC5C,+BAA+B,cAAc,EAAE;AAC/C,wBAAwB,cAAc,EAAE","sourcesContent":["/* ════════════════════════════════════════════════════════\n   Account & Subscription screen\n   ════════════════════════════════════════════════════════ */\n\n/* ── RBAC access-denied state ────────────────────────── */\n.as-access-denied {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 300px;\n  padding: 40px 24px;\n  text-align: center;\n  background: #f8fafc;\n}\n.as-access-denied-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n.as-access-denied-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1e293b;\n  margin: 0 0 8px;\n}\n.as-access-denied-body {\n  font-size: 14px;\n  color: #64748b;\n  max-width: 380px;\n  line-height: 1.6;\n  margin: 0 0 24px;\n}\n.as-access-denied-btn {\n  padding: 10px 24px;\n  background: #3b82f6;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n.as-access-denied-btn:hover {\n  background: #2563eb;\n}\n\n.as-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: #f8fafc;\n  font-family: inherit;\n}\n\n/* ── Header ─────────────────────────────────────────────── */\n.as-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  background: #fff;\n  border-bottom: 1.5px solid #e2e8f0;\n  flex-shrink: 0;\n}\n.as-back {\n  width: 32px;\n  height: 32px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 50%;\n  background: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #475569;\n  flex-shrink: 0;\n  transition: border-color 0.15s, background 0.15s;\n}\n.as-back:hover { background: #f1f5f9; border-color: #cbd5e1; }\n.as-header-title { font-size: 15px; font-weight: 700; color: #0f172a; margin: 0; }\n.as-header-sub   { font-size: 11.5px; color: #64748b; margin: 1px 0 0; }\n\n/* ── Scroll body ─────────────────────────────────────────── */\n.as-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 18px 20px 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n/* ── Meta chips row ──────────────────────────────────────── */\n.as-chips-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.as-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 12px 5px 9px;\n  border-radius: 20px;\n  font-size: 11.5px;\n  font-weight: 600;\n  border: 1px solid;\n}\n.as-chip-blue {\n  background: #2563eb1a;\n  border-color: #2563eb33;\n  color: #1d4ed8;\n}\n.as-chip-navy {\n  background: #1e3a5f1a;\n  border-color: #1e3a5f33;\n  color: #1e3a5f;\n}\n.as-chip svg { flex-shrink: 0; }\n\n/* ── Timestamp + refresh row ─────────────────────────────── */\n.as-meta-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.as-updated {\n  font-size: 11px;\n  color: #94a3b8;\n}\n.as-refresh-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 16px;\n  border-radius: 12px;\n  border: 1.5px solid #2563eb33;\n  background: #eef3ff;\n  color: #2563eb;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n  white-space: nowrap;\n}\n.as-refresh-btn:hover { background: #dbeafe; }\n.as-refresh-btn:disabled { opacity: 0.55; cursor: not-allowed; }\n.as-refresh-spinner {\n  width: 13px;\n  height: 13px;\n  border: 2px solid #2563eb44;\n  border-top-color: #2563eb;\n  border-radius: 50%;\n  animation: as-spin 0.7s linear infinite;\n}\n@keyframes as-spin { to { transform: rotate(360deg); } }\n\n/* ── Empty state ─────────────────────────────────────────── */\n.as-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  gap: 12px;\n  text-align: center;\n}\n.as-empty-icon {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  background: #2563eb14;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #2563eb;\n}\n.as-empty-title { font-size: 15px; font-weight: 700; color: #0f172a; margin: 0; }\n.as-empty-msg   { font-size: 13px; color: #64748b; margin: 0; max-width: 300px; }\n\n/* ── Generic card ────────────────────────────────────────── */\n.as-card {\n  background: #fff;\n  border-radius: 18px;\n  border: 1.5px solid #e2e8f0;\n  overflow: hidden;\n  box-shadow: 0 2px 8px 0 #0000000a;\n}\n\n/* ── Card accent header ──────────────────────────────────── */\n.as-card-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 13px 16px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n.as-card-header-blue   { background: #2563eb12; color: #1d4ed8; }\n.as-card-header-purple { background: #7c3aed12; color: #6d28d9; }\n.as-card-header-amber  { background: #d9770614; color: #b45309; }\n.as-card-header-red    { background: #dc262614; color: #b91c1c; }\n\n/* ── Plan / billing banner ───────────────────────────────── */\n.as-plan-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 14px 16px;\n  border-bottom: 1px solid #f1f5f9;\n}\n.as-plan-name { font-size: 20px; font-weight: 700; color: #0f172a; }\n\n.as-billing-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 13px 16px;\n  background: #7c3aed07;\n  border-bottom: 1px solid #f1f5f9;\n}\n.as-billing-banner-left  { display: flex; flex-direction: column; gap: 2px; }\n.as-billing-banner-right { display: flex; flex-direction: column; align-items: flex-end; gap: 2px; }\n.as-billing-label { font-size: 11px; color: #64748b; font-weight: 500; }\n.as-billing-amount { font-size: 19px; font-weight: 700; color: #0f172a; }\n.as-billing-due-days { font-size: 14px; font-weight: 700; color: #7c3aed; }\n\n/* ── Status badge ────────────────────────────────────────── */\n.as-status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n}\n.as-status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.as-status-active   { background: #05966914; color: #059669; }\n.as-status-active   .as-status-dot { background: #059669; }\n.as-status-inactive { background: #dc262614; color: #dc2626; }\n.as-status-inactive .as-status-dot { background: #dc2626; }\n.as-status-other    { background: #d9770614; color: #d97706; }\n.as-status-other    .as-status-dot { background: #d97706; }\n\n/* ── Data rows (label + value) ───────────────────────────── */\n.as-rows { padding: 6px 0 8px; }\n.as-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  padding: 9px 16px;\n  border-bottom: 1px solid #f8fafc;\n  gap: 12px;\n}\n.as-row:last-child { border-bottom: none; }\n.as-row-label {\n  font-size: 12px;\n  color: #64748b;\n  font-weight: 500;\n  flex-shrink: 0;\n}\n.as-row-value {\n  font-size: 12.5px;\n  color: #0f172a;\n  font-weight: 600;\n  text-align: right;\n  word-break: break-all;\n}\n.as-row-value-purple { color: #7c3aed; }\n\n/* ── Features collapsible ────────────────────────────────── */\n.as-features-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 16px;\n  border-top: 1px solid #f1f5f9;\n  cursor: pointer;\n  background: none;\n  border-bottom: none;\n  border-left: none;\n  border-right: none;\n  width: 100%;\n  font-size: 12px;\n  font-weight: 600;\n  color: #475569;\n  transition: background 0.12s;\n}\n.as-features-toggle:hover { background: #f8fafc; }\n.as-features-chevron { transition: transform 0.2s; }\n.as-features-chevron.open { transform: rotate(180deg); }\n\n.as-features-body { padding: 4px 16px 12px; }\n.as-feat-group-label {\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  padding: 8px 0 4px;\n}\n.as-feat-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 0;\n  font-size: 12px;\n  color: #334155;\n}\n.as-feat-icon-ok  { color: #059669; flex-shrink: 0; }\n.as-feat-icon-no  { color: #dc2626; flex-shrink: 0; }\n\n\n/* ── Addon rows ──────────────────────────────────────────── */\n.as-addon-list { display: flex; flex-direction: column; }\n.as-addon-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 16px;\n  border-bottom: 1px solid #f8fafc;\n}\n.as-addon-row:last-child { border-bottom: none; }\n.as-addon-left  { display: flex; flex-direction: column; gap: 3px; flex: 1; min-width: 0; }\n.as-addon-right { display: flex; flex-direction: column; align-items: flex-end; gap: 4px; flex-shrink: 0; }\n.as-addon-name  { font-size: 13px; font-weight: 700; color: #0f172a; }\n.as-addon-desc  { font-size: 11.5px; color: #64748b; line-height: 1.4; }\n.as-addon-id    { font-size: 10.5px; color: #94a3b8; }\n.as-addon-badges { display: flex; flex-wrap: wrap; gap: 5px; margin-top: 2px; }\n.as-category-pill {\n  display: inline-flex;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 700;\n  background: #d9770614;\n  color: #b45309;\n}\n.as-addon-cycle { font-size: 11px; color: #94a3b8; margin-top: 1px; }\n.as-addon-price-free  { font-size: 14px; font-weight: 700; color: #059669; }\n.as-addon-price       { font-size: 14px; font-weight: 700; color: #b45309; }\n.as-addon-dates       { font-size: 10.5px; color: #94a3b8; text-align: right; }\n.as-addon-empty       { padding: 14px 16px; font-size: 12px; color: #94a3b8; }\n\n/* ── Dark mode ───────────────────────────────────────────── */\nbody.dark .as-container { background: #0f172a; }\nbody.dark .as-header    { background: #1e293b; border-color: #334155; }\nbody.dark .as-header-title { color: #f1f5f9; }\nbody.dark .as-header-sub   { color: #94a3b8; }\nbody.dark .as-back      { background: #1e293b; border-color: #334155; color: #94a3b8; }\nbody.dark .as-card      { background: #1e293b; border-color: #334155; box-shadow: none; }\nbody.dark .as-row       { border-color: #1e293b; }\nbody.dark .as-row-label { color: #94a3b8; }\nbody.dark .as-row-value { color: #e2e8f0; }\nbody.dark .as-plan-banner { border-color: #334155; }\nbody.dark .as-plan-name   { color: #f1f5f9; }\nbody.dark .as-addon-name  { color: #f1f5f9; }\nbody.dark .as-features-toggle { color: #94a3b8; }\nbody.dark .as-features-toggle:hover { background: #0f172a; }\nbody.dark .as-feat-group-label { color: #64748b; }\nbody.dark .as-feat-row  { color: #cbd5e1; }\nbody.dark .as-addon-row { border-color: #1e293b; }\nbody.dark .as-addon-desc { color: #94a3b8; }\nbody.dark .as-empty-title { color: #f1f5f9; }\nbody.dark .as-billing-amount { color: #f1f5f9; }\nbody.dark .as-updated { color: #475569; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
